export default {
  DDI_ROUTING_ENABLED: 'ddi_routing_enabled',
  DDI_ROUTING_INITIATED: 'ddi_routing_initiated',
  DEFAULT_QUEUE_SID: 'default_queue_sid',
  DIRECT_CALL_TIMEOUT_SECONDS: 'direct_call_timeout_seconds',
  WRAP_UP_TIME_INITIATED: 'wrap_up_time_initiated',
  WRAP_UP_TIME_ENABLED: 'wrap_up_time_enabled',
  WRAP_UP_TIME_SECONDS: 'wrap_up_time_seconds',
};
